// node_modules
import { FC } from "react";

type TAsynchronousWrapper = {
    isLoading: boolean;
    didError: boolean;
    errorMessage: string;
    children: JSX.Element | (JSX.Element | null)[];
    LoaderComponent: FC | null;
};

export const AsynchronousWrapper: FC<TAsynchronousWrapper> = ({isLoading, didError, errorMessage, LoaderComponent, children}: TAsynchronousWrapper) => {
    return (
        <>
            {isLoading && LoaderComponent ? <LoaderComponent /> : <></>}
            {didError && 
                <div style={{width: "100%", height: "100%", textAlign: "center"}}>
                    <p>{errorMessage}</p>
                </div>
            } 
            {(!isLoading && !didError) && children}
        </>
    );
};
